function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M50,100C22.4,100,0,77.6,0,50C0,22.4,22.4,0,50,0c27.6,0,50,22.4,50,50C100,77.6,77.6,100,50,100z M50,3.3                                                     C24.3,3.3,3.3,24.3,3.3,50c0,25.7,20.9,46.7,46.7,46.7c25.7,0,46.7-20.9,46.7-46.7C96.7,24.3,75.7,3.3,50,3.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M47.4,70.4c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5L61,52.1l-27.3,0                                                         c-1.2,0-2.1-1-2.1-2.1c0-1.2,1-2.1,2.1-2.1H61L45.9,33.2c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5                                                         c0.4-0.4,0.9-0.6,1.5-0.6c0.6,0,1.1,0.2,1.5,0.6l18.6,18.1l0,0.1l0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2                                                         c0.1,0.2,0.2,0.4,0.3,0.7c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.5-0.3,0.7c0,0-0.1,0.1-0.1,0.1                                                         c-0.1,0.1-0.1,0.2-0.2,0.2l-0.1,0.1l0,0.1L48.9,69.8C48.5,70.2,48,70.4,47.4,70.4z"
}))));

var SvgRating = function SvgRating(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "rate-svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating.3951eff9.svg";
export { ForwardRef as ReactComponent };